import { configureStore } from "@reduxjs/toolkit"
import admin from "./admin"
import schools from "./schools"
import students from "./students"
import teachers from "./teachers"
import expenses from "./expenses"
import schooldetails from "./schooldetails"
import Class_ from "./class"
import offline from "./offline"
import announcement_ from "./announcement"
import messages from "./messages"
import chat from "./chat"
import siren from "./siren"
import assets from "./assets"
import sales from "./sales"
import accounting from "./accounting"

export default configureStore({
    reducer: {
        assets: assets,
        siren: siren,
        admin: admin,
        schools: schools,
        students: students,
        teachers: teachers,
        expenses: expenses,
        schooldetails: schooldetails,
        class: Class_,
        offline: offline,
        announcement: announcement_,
        messages: messages,
        chat: chat,
        sales: sales,
        accounting: accounting
    }
})